<template>
  <SideBarLayoutContent>
    <template #top-bar>
      <h1 class="text-display-small grow">{{ teamName }}</h1>
    </template>
    <BaseTabGroup :tab-items="tabItems">
      <BaseTabBar :tab-items="tabItems" class="mb-4 border-b" />
      <TabPanels>
        <TabPanel>
          <TeamMemberList />
        </TabPanel>
        <TabPanel>
          <TeamImpulsePanel :team-id="teamId" />
        </TabPanel>
        <TabPanel v-if="canManagePortal">
          <TeamPortalPanel :team-id="teamId" />
        </TabPanel>
      </TabPanels>
    </BaseTabGroup>
  </SideBarLayoutContent>
</template>
<script lang="ts" setup>
  import { computed } from 'vue'
  import { TabPanel, TabPanels } from '@headlessui/vue'
  import { useI18n } from 'vue-i18n'
  import { useRoute } from 'vue-router'
  import SideBarLayoutContent from '@/core/components/layouts/SideBarLayoutContent.vue'
  import BaseTabBar from '@/core/components/base/tab-bar/BaseTabBar.vue'
  import BaseTabGroup from '@/core/components/base/tab-bar/BaseTabGroup.vue'
  import { usePermission } from '@/core/composables/use-permission'
  import { Permission } from '@/core/models/user'
  import { useTeamsStore } from '@/stores/teams.store'
  import TeamMemberList from '../components/TeamMemberList.vue'
  import TeamImpulsePanel from '../components/TeamImpulsePanel.vue'
  import TeamPortalPanel from '@/modules/portal/components/TeamPortalPanel.vue'

  const { t } = useI18n()
  const route = useRoute()
  const { can } = usePermission()
  const teamStore = useTeamsStore()
  const teamId = computed(() => route.params.teamId as string)

  const canManagePortal = computed(() => can(Permission.PORTAL_MANAGE))

  const tabItems = computed(() => {
    const items = [
      { id: 'members', title: t('portal.membersTab') },
      { id: 'impulses', title: t('lumia.lesson.teamTab') },
    ]
    if (canManagePortal.value) {
      items.push({ id: 'portal', title: t('portal.tab') })
    }
    return items
  })

  const teamName = computed(
    () => teamStore.allTeams.find((team) => team.id === teamId.value)?.name ?? '',
  )
</script>
